module.exports = __webpack_public_path__ + "img/8.395a4647.png";